<template>
  <div class="available-options">
    <h3 class="available-options__title">Доступные возможности</h3>
    <div class="flex flex-col gap-4">
      <div class="flex space-between available-options__el">
        <div>Управление заявками</div>
        <VCheckbox v-model="form.permissions.control"/>
      </div>
      <div class="flex space-between available-options__el">
        <div>Согласование заявок</div>
        <VCheckbox v-model="form.permissions.approve"/>
      </div>
      <div class="flex space-between available-options__el">
        <div>Взятие заявок в работу</div>
        <VCheckbox v-model="form.permissions.takeToWork"/>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed} from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
});

const form = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});
</script>
<style lang="scss" scoped>
.available-options {
  position: relative;
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0px #0000000A;

  &__title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__el {
    height: 28px;
    align-items: center;
    color: $dark;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
  }
}
</style>